export default __webpack_public_path__ + "media/images/chat-person-fa0f41ec480fb2f19e47388693c5e845.svg";